<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col v-if="donePicks.length <= 0" cols="12" sm="12">
            <v-card class="elevation-0">
                <v-alert height="60vh" class=" d-flex justify-center" elevation="0">Keine Abgeschlossenen Picks.</v-alert>
            </v-card>
        </v-col>
        <v-col v-for="(donePick, indx) in donePicks" :key="indx" cols="12" md="6" sm="12">
          <v-card class="elevation-3" tile>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="headline">{{donePick.pixi_id}}</v-list-item-title>
                <v-list-item-subtitle>Erstellt von {{donePick.created_from}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list>
              <v-list-item>
                <v-icon>mdi-package-variant</v-icon>
                <v-list-item-title class="ml-3">Box:</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{donePick.box_from}}-{{donePick.box_to}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-icon>mdi-calendar-clo<h1>Hello!</h1>ck</v-icon>
                <v-list-item-title class="ml-3">Erstellt am:</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{formatDate(donePick.created_at)}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-icon>mdi-calendar-clock</v-icon>
                <v-list-item-title class="ml-3">Ablaufdatum:</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{formatDate(donePick.expires_at)}}</v-list-item-subtitle>
              </v-list-item>
            </v-list>
            <v-divider />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import datetimeFormatter from "../helpers/datetimeFormatter";

export default {
  name: "DonePicksList",
  computed: mapState({
    donePicks: state => state.picklists.donePicklist,
  }),
  methods: {
    formatDate(value) {
      return datetimeFormatter.formatIntoDateTime(value);
    }
  }
};
</script>